/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import PopupPicker from "vux/src/components/popup-picker/index.vue"; // this line is trasformed by vux-loader
export default {
  components: {
    XButton: XButton,
    PopupPicker: PopupPicker
  },
  props: {
    input: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: i18n.tc("239")
    },
    height: {
      type: Number,
      default: 0
    },
    detail: {
      type: Boolean,
      default: false
    },
    picker: {
      type: Boolean,
      default: false
    },
    pickerList: {
      type: Array,
      default: function _default() {
        return []; // 格式为name:'xx', value: 'xx'
      }
    },
    pickerValue: {
      default: ''
    },
    sizeflag: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      detailShow: false,
      // 拓展搜索 显示
      pickerCurrValue: this.pickerValue ? [this.pickerValue] : [],
      // 单选控件 值
      pickerShow: false // 单选控件 显示
    };
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('input', val);
    },
    pickerValue: function pickerValue(val) {
      this.pickerCurrValue = val ? [val] : [];
    }
  },
  computed: {
    pickerCurrName: function pickerCurrName() {
      var _this = this;
      var item = this.pickerList.filter(function (item) {
        return item.value + '' === _this.pickerCurrValue + '';
      });
      if (item.length > 0) {
        return item[0].name;
      }
      return '';
    }
  },
  methods: {},
  created: function created() {}
};